import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  margin: 10px 0;
  padding: ${props => (props.noBorderTop ? '0' : '20px 0')};
  border-top: ${props => (props.noBorderTop ? 'none' : `1px solid ${props.theme.color.monochrome.light}`)};

  &:nth-child(1) {
    padding: 32px 0 0 0;
  }

  &:last-child {
    border-bottom: none;
  }
`

const IconColumn = styled.div`
  width: 45px;
`

const HeadingColumn = styled.div`
  width: 120px;
  padding-right: 10px;
`

const Heading = styled.span`
  font-weight: ${props => props.theme.font.weight.bold};
`

const DescriptionColumn = styled.div`
  flex: 1;
`

export { Container, IconColumn, HeadingColumn, Heading, DescriptionColumn }
